export default __webpack_public_path__ + "static/media/footerdesign.12540af7.svg";